import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useConfirmReportingCheckoutSessionMutation } from '@cast/shared-trial-data-access';

const SESSION_ID_PARAM = 'session_id';

/**
 * After Stripe Checkout redirect, confirm the session once via
 * POST …/checkout-session/confirm using ?session_id=, then clear the param.
 */
export const useConfirmReportingCheckoutOnReturn = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const confirmMutation = useConfirmReportingCheckoutSessionMutation();
  const handledRef = useRef<string | null>(null);

  const sessionId = searchParams.get(SESSION_ID_PARAM);

  useEffect(() => {
    if (!sessionId || handledRef.current === sessionId) {
      return;
    }
    handledRef.current = sessionId;

    confirmMutation.mutate(sessionId, {
      onSettled: () => {
        setSearchParams(
          (prev) => {
            const next = new URLSearchParams(prev);
            next.delete(SESSION_ID_PARAM);
            return next;
          },
          { replace: true }
        );
      },
    });
    // Intentionally only react to sessionId appearing in the URL.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mutate/setSearchParams stable enough; avoid re-confirm loops
  }, [sessionId]);
};
